export default class WebhookService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getAllWebhooks(args) {
    return this.axiosIns.get(this.serviceConfig.webhooks, { params: args });
  }

  getWebhook(id) {
    return this.axiosIns.get(`${this.serviceConfig.webhooks}/${id}`);
  }

  createWebhook(args) {
    return this.axiosIns.post(this.serviceConfig.webhooks, args);
  }

  editWebhook(id, args) {
    return this.axiosIns.put(`${this.serviceConfig.webhooks}/${id}`, args);
  }

  deleteWebhook(id) {
    return this.axiosIns.delete(`${this.serviceConfig.webhooks}/${id}`);
  }
}
